import { render, staticRenderFns } from "./ImportMarkingsDialog.vue?vue&type=template&id=5434820f"
import script from "./ImportMarkingsDialog.vue?vue&type=script&lang=js"
export * from "./ImportMarkingsDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportMarkingsDialog.vue?vue&type=style&index=0&id=5434820f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports